import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.jsx';

// Auto-hide scrollbar functionality
const initAutoHideScrollbars = () => {
  let scrollTimeout;
  let mainScrollTimeout;
  
  const handleScroll = (element) => {
    // Add scrolling class
    element.classList.add('scrolling');
    
    // Clear existing timeout
    clearTimeout(scrollTimeout);
    
    // Set timeout to remove scrolling class after scroll stops
    scrollTimeout = setTimeout(() => {
      element.classList.remove('scrolling');
    }, 1000); // Hide scrollbar after 1 second of no scrolling
  };
  
  // Handle main page scroll
  const handleMainPageScroll = () => {
    // Add scrolling class to html element
    document.documentElement.classList.add('scrolling');
    
    // Clear existing timeout
    clearTimeout(mainScrollTimeout);
    
    // Set timeout to remove scrolling class after scroll stops
    mainScrollTimeout = setTimeout(() => {
      document.documentElement.classList.remove('scrolling');
    }, 1000); // Hide scrollbar after 1 second of no scrolling
  };
  
  // Add scroll listeners to all scrollable elements
  const addScrollListeners = () => {
    const scrollableElements = document.querySelectorAll(
      '.modal-content, .dropdown-menu, [class*="overflow"], [style*="overflow"]'
    );
    
    scrollableElements.forEach(element => {
      element.addEventListener('scroll', () => handleScroll(element), { passive: true });
    });
  };
  
  // Add main page scroll listener
  const addMainPageScrollListener = () => {
    window.addEventListener('scroll', handleMainPageScroll, { passive: true });
  };
  
  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      addScrollListeners();
      addMainPageScrollListener();
    });
  } else {
    addScrollListeners();
    addMainPageScrollListener();
  }
  
  // Re-initialize when new content is added (for dynamic content)
  const observer = new MutationObserver(() => {
    addScrollListeners();
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
};

// Initialize auto-hide scrollbars
initAutoHideScrollbars();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 